/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Mode_Bill_LabelInputs */



/**
* | output |
* | --- |
* | "Bill the accumulated history" |
*
* @param {Partner_Admin_Billing_Mode_Bill_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_mode_bill_label = /** @type {((inputs?: Partner_Admin_Billing_Mode_Bill_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Mode_Bill_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgelaufene Historie abrechnen")
	return /** @type {LocalizedString} */ ("Bill the accumulated history")
});